export const PLAN_RANK = { none: 0, trial: 0, core: 1, performance: 2, executive: 3 };

// Legacy plan codes retained for firms created before the pricing overhaul.
const LEGACY_PLAN_MAP = { essentials: "core", growth: "core", agency: "executive" };

export const FEATURE_MIN_PLAN = {
  scorecards: "core",
  ai_invoice: "performance",
  compliance: "performance",
  alerts: "performance",
};

export const PLAN_LABELS = {
  core: "RetainProof Core",
  performance: "RetainProof Performance",
  executive: "RetainProof Executive Oversight",
};

export function normalizePlan(plan) {
  return LEGACY_PLAN_MAP[plan] || plan;
}

export function hasFeature(plan, feature) {
  const p = normalizePlan(plan);
  return (PLAN_RANK[p] || 0) >= (PLAN_RANK[FEATURE_MIN_PLAN[feature]] || 0);
}
